
import React from 'react';
import { BUSINESS_INFO } from '../constants';
import { AlertTriangle, Info, ShieldCheck, Stethoscope } from 'lucide-react';

const Disclaimer: React.FC = () => {
  return (
    <div className="bg-transparent min-h-screen py-20 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-white p-8 md:p-16 rounded-[3rem] shadow-2xl border border-slate-50 reveal-up">
          <div className="flex items-center space-x-4 mb-10">
            <div className="bg-amber-500 p-4 rounded-2xl shadow-xl shadow-amber-500/20 animate-pulse">
              <AlertTriangle className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900">Legal Disclaimer</h1>
          </div>
          
          <div className="space-y-10 text-slate-600 leading-relaxed text-lg">
            <div className="bg-amber-50 border-l-8 border-amber-500 p-8 rounded-r-3xl">
              <h3 className="text-amber-900 font-bold mb-4 flex items-center">
                <Info className="w-5 h-5 mr-2" /> Essential Notice
              </h3>
              <p className="text-amber-800">
                The information provided by <strong>{BUSINESS_INFO.name}</strong> on our website and through our communications is for general wellness and lifestyle purposes only.
              </p>
            </div>

            <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="p-6 rounded-3xl bg-slate-50 border border-slate-100">
                <div className="bg-teal-100 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                  <Stethoscope className="text-teal-600" />
                </div>
                <h4 className="font-bold text-slate-900 mb-2">Not Medical Advice</h4>
                <p className="text-sm">Our products and services are not intended to diagnose, treat, cure, or prevent any medical condition or disease.</p>
              </div>
              <div className="p-6 rounded-3xl bg-slate-50 border border-slate-100">
                <div className="bg-sky-100 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                  <ShieldCheck className="text-sky-600" />
                </div>
                <h4 className="font-bold text-slate-900 mb-2">Results May Vary</h4>
                <p className="text-sm">The efficacy of wellness solutions is subjective and depends on biology, lifestyle, and consistency.</p>
              </div>
            </section>

            <section className="space-y-6">
              <p>
                <strong>Professional Consultation:</strong> Always consult a qualified healthcare professional, doctor, or medical specialist before starting any new wellness routine or using lifestyle products, particularly if you have pre-existing health conditions or are under medication.
              </p>
              <p>
                By using our website and services, you acknowledge that <strong>{BUSINESS_INFO.name}</strong> is a lifestyle business and not a medical provider. Any content provided is intended to support, not replace, professional clinical guidance.
              </p>
            </section>

            <div className="pt-10 border-t border-slate-100 text-center">
              <p className="text-sm text-slate-400 font-medium">
                Sangeeta Wellness | MSME Registered: {BUSINESS_INFO.taxId}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
